import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 10000,
  },
  body: {
    position: 'absolute',
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    padding: 30,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  stage: {
    backgroundColor: 'rgba(0,0,0,.9)',
    zIndex: 1000,
    padding: 30,
    position: 'absolute',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  header: {
    zIndex: 9,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  content: {
    zIndex: 9,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  footer: {
    zIndex: 8,
    height: 120,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflowX: 'auto',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      display: 'none',
      width: 5,
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.primary.main,
    },
  },
  picture: {
    borderRadius: theme.shape.borderRadius * 2,
    overflow: 'hidden',
    boxShadow: theme.shadows[12],
    transition: 'all 150ms ease-in-out',
    transform: (useStylesParams) =>
      `scale(${useStylesParams.zoom}) rotate(${useStylesParams.rotate}deg)`,
  },
  thumbnail: {
    minWidth: 100,
    height: 100,
    backgroundColor: 'rgba(255,255,255,1)',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    marginRight: 15,
    cursor: 'pointer',
    opacity: 0.5,
    transition: 'all 150ms ease-in-out',
    '&:hover': {
      boxShadow: theme.shadows[6],
      opacity: 1,
      transform: `scale(1.1)`,
    },
  },
  thumbnailActive: {
    minWidth: 100,
    height: 100,
    backgroundColor: 'rgba(255,255,255,1)',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    marginRight: 15,
    cursor: 'pointer',
    opacity: 1,
    transform: `scale(1.1)`,
    transition: 'all 150ms ease-in-out',
    '&:hover': {
      boxShadow: theme.shadows[6],
      opacity: 1,
      transform: `scale(1.1)`,
    },
  },
}))

export default useStyles
